import type { FaireProductEntity } from "../../entity_types/product";

export const p_ekkpeqxzm5: FaireProductEntity = {
  token: "p_ekkpeqxzm5",
  type: "product",
  name: "Jesus Lover Faith Based Graphic Tee",
  brandToken: "b_2j7xk5pwsc",
  brandName: "TheKingShirt",
  imageUrl:
    "https://cdn.faire.com/fastly/d1592af813c4d6bd32727ff2704915b2793803880b940c650eccf664dc9c8530.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ae9b62182c97a299646b41011dfca107860911e197a93d15ab86312085fdd02f.jpeg",
    "https://cdn.faire.com/fastly/1737b9031c94c89214370246b87fe89a07dab35822fe14a06a2d05b147f971bf.jpeg",
    "https://cdn.faire.com/fastly/8bf212fbed220b252d2b6636bb5419da28a5dc26cf9917e9d7d36ed2038d8fc0.jpeg",
    "https://cdn.faire.com/fastly/f2538ad5423cc05d075c9244ef25143f41e6cf048fb06491904253e6dd9a77a7.jpeg",
    "https://cdn.faire.com/fastly/795fe1c457a98c066a59193e3f0c99ea30698975e480c8a3be4f1e0b87610b2b.jpeg",
  ],
  priceDollars: 17.99,
  description:
    "Product Details:\n•We use 100% cotton shirts.\n• All shirts are unisex and we use our own brand. (Please check our size chart in our listing.)\n•Heather colored adult shirts use 52% cotton and 48% polyester.\n\n-For detailed sizing information and t-shirt color options, please see listing images.\nOur shirts are small molded. It may be small for your normal size. Please refer to our size chart carefully before ordering.\n-Please check the our size chart and color of the shirt you want before ordering.\n\nWASHING INSTRUCTIONS:\nTurn inside out.\nMachine wash cold.\nTumble dry low.\nDo not bleach.\nDo not iron directly on design.\nHigh quality and super soft, comfortable tshirts.\n\nProcess and Shipping:\nProduction Time 1-3 business day\nUSA Orders / Standard: 3 to 7 business days\nUSA Orders / Rush: 3 to 5 business days\nInternational Orders: 1-2 weeks",
  tags: [],
  msrpDollars: 24.29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:15.725Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
